/* eslint-disable @typescript-eslint/no-unused-vars */
// Angular
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// Auth reducers and selectors
import { AppState } from '../../../core/reducers/';
import { canEditProfile } from '../_selectors/auth.selectors';

@Injectable()
export class RestrictedGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.pipe(
      select(canEditProfile),
      tap(res => {
        if (!res) {
          this.router.navigateByUrl('/');
        }
      })
    );
  }
}
